module.exports = "Favourite Quotes\n----------------\n\n\"I'm on a roller coaster that only goes up.\" - John Green\n\"The world wasn't made for us, we were made for the world\" - John Green\n\"That's the thing about pain. It demands to be felt\" - John Green\n\"Some infinities are bigger than others\" - John Green\n\nAs you can see, I'm clearly a fan of John Green. Especially of his novel The Fault in Our Stars.\n\nInterests\n---------\n\nI'm interested in electronics, computers and natural sciences, especially physics. Robotics is also quite cool.\nI also like to think about some quite deep philosophical questions."


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./me.txt
 ** module id = 81
 ** module chunks = 0 1
 **/